import DropDown from 'components/BoxFieldset/DropDown.react';
import types from 'components/BoxFieldset/Constants';
import AccountManager from 'lib/AccountManager';
import Field from 'components/Field/Field.react';
import Fieldset from 'components/Fieldset/Fieldset.react';
import EmptyState from 'components/EmptyState/EmptyState.react';
import FormButton from 'components/FormButton/FormButton.react';
import FormModal from 'components/FormModal/FormModal.react';
import FormTable from 'components/FormTable/FormTable.react';
import Toggle from 'components/Toggle/Toggle.react';
import KeyField from 'components/KeyField/KeyField.react';
import Label from 'components/Label/Label.react';
import Modal from 'components/Modal/Modal.react';
import modalStyles from 'components/Modal/Modal.scss';
import Parse from 'parse';
import React from 'react';
import history from 'dashboard/history';
import renderFlowFooterChanges from 'lib/renderFlowFooterChanges';
import PreLoader from 'components/PreLoader/PreLoader.react';
import settingsStyles from 'dashboard/Settings/Settings.scss';
import styles from './Backup.scss';
import stylesButton from 'components/Button/Button.scss';
import TextInput from 'components/TextInput/TextInput.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import TeamDesk from 'components/TeamDesk/TeamDesk.react';
import { dateStringUTC } from 'lib/DateUtils';
import UploadAvatarOrIcon from 'components/UploadAvatarOrIcon/UploadAvatarOrIcon.react';
import Notification from 'components/Notification/Notification.react';

export default class BackupsActivation extends React.Component {
  constructor(props) {
    super();
    this.section = 'Automatic Database Backups';

    this.state = {
      loading: false,
      showActivateBackupsModal: false,
      showAfterActivationThankYouMessage: false,
      showDeActivateBackupsModal: false,
      showAfterDeActivationThankYouMessage: false,
      note: {},
      password: '',
      isTeamDeskOpen: false,
    };
  }

  async componentDidMount() {
    const { currentUser } = await AccountManager.currentUser();

    if (this.props.location.state && this.props.location.state.activate) {
      this.state.showActivateBackupsModal = this.props.location.state.activate;
    }

    this.setState({
      showAlreadyComponent: currentUser.backups_enabled,
    });
  }

  componentWillUpdate() {
    let _this = this;
    setTimeout(() => {
      _this.setState({ note: {} });
    }, 7000);
  }

  notActivateBackups() {
    history.push('/products/apps');
  }

  activateBackups() {
    this.setState({ showActivateBackupsModal: true });
  }

  deActivateBackups() {
    this.setState({ showDeActivateBackupsModal: true });
  }

  navigateToAddCard() {
    history.push('billing/add_card');
  }

  handleTeamDeskOpen() {
    this.setState({ isTeamDeskOpen: true });
  }

  render() {
    let classes = [settingsStyles.settings_page, settingsStyles.default];

    let activateBackupsModal =
      <FormModal
        title='Activate Automatic Database Backups'
        type={Modal.Types.INFO}
        open={this.state.showActivateBackupsModal}
        submitText='Activate for $15/mo'
        inProgressText={'Activating\u2026'}
        enabled={this.state.password.length > 0}
        onSubmit={() =>
          AccountManager.setBackupsEnabled({state: true, password: this.state.password}).then(() => {
            this.setState({
              showAfterActivationThankYouMessage: true,
              showAfterDeActivationThankYouMessage: false,
            });

            setTimeout(() => {
              window.location.reload();
            }, 3000)
          })
        }
        onClose={() => {
          history.replace("/backups", {state: { activate: false }} )
          this.setState({
            showActivateBackupsModal: false
          })
        }}
        clearFields={() => this.setState({password: ''})}
      >

        <p className={modalStyles.only}>I am aware that this is an extra service<br /> which costs <strong>$15 per account monthly</strong></p>
        <div className={modalStyles.hr} />

        <Field
          labelWidth={60}
          label={<Label text='Your password' /> }
          input={<TextInput
            hidden={true}
            value={this.state.password}
            placeholder='Password'
            onChange={(newValue) => { this.setState({password: newValue}); }}
          />}
        />
      </FormModal>

    let deActivateBackupsModal =
      <FormModal
        title='Deactivate Automatic Database Backups'
        type={Modal.Types.DANGER}
        open={this.state.showDeActivateBackupsModal}
        submitText='Deactivate'
        inProgressText={'Deactivating\u2026'}
        enabled={this.state.password.length > 0}
        onSubmit={() => AccountManager.setBackupsEnabled({state: false, password: this.state.password}).then(() => {
          this.setState({
            showAfterDeActivationThankYouMessage: true,
          })
        })}
        onClose={() => {
          history.replace("/backups", {state: { activate: false }} )
          this.setState({
            showDeActivateBackupsModal: false
          })
        }}
        clearFields={() => this.setState({password: ''})}
      >

        <p className={modalStyles.only}>If you deactivate the feature, you will be charged for it on your next billing.<br /><br />After deactivation, the backups will still be active until the next billing comes.</p>

        <div className={modalStyles.hr} />

        <Field
          labelWidth={60}
          label={<Label text='Your password' /> }
          input={<TextInput
            hidden={true}
            value={this.state.password}
            placeholder='Password'
            onChange={(newValue) => { this.setState({password: newValue}); }}
          />}
        />
      </FormModal>

    let activateComponent =
        <EmptyState
          title="Activate Automatic Database Backups for all of your apps!"
          smallTitle={true}
          descriptionWithHTML="
            <div style='text-align: left;width: 560px;margin: 20px auto 30px;font-size: 14px;border: 1px solid #dedede;background-color: #fff;padding: 20px;border-radius: 4px;'>
              😞 Oops...&#34;All records deleted successfully!&#34; - System message<br />
              😣 Duh...&#34;Hey, I'm the newbie and I just deleted our database!&#34; - the New Guy<br />
              😬 Ouch...&#34;Fire Alarm! Evacuate immediately, leave everything behind!&#34; - Fire Alarm<br />
              😱 OMG!...&#34;That data lost episode will cost us about 20-30K&#34; - the Accountant<br /><br />
              <strong>Sounds familiar, right? Never lose sight of your data and save yourself the hassle!</strong>
            </div>
            <strong>ONLY $15 per month!</strong><br />"
          cta='Activate Automatic Backups'
          action={this.activateBackups.bind(this)}
        />

    let afterActivationThankYouMessage =
        <EmptyState
          title="Automatic Database Backups were successfully activated!"
          smallTitle={true}
          descriptionWithHTML="Every day a backup copy of your apps will be automatically created."
          cta='View your applications'
          action={this.notActivateBackups.bind(this)}
        />

    let alreadyActivated =
        <EmptyState
          title="You have active Automatic Database Backups for your account!"
          smallTitle={true}
          descriptionWithHTML="You can deactivate them any time, but you will still pay for the period you have used them on your next billing date."
          ctaColor='red'
          cta='Deactivate Automatic Database Backups'
          action={this.deActivateBackups.bind(this)}
        />

    let afterDeActivationThankYouMessage =
        <EmptyState
          title="Automatic Database Backups were deactivated!"
          smallTitle={true}
          descriptionWithHTML="If you decide you want to continue automatically back up your apps, click on the button below."
          cta='Activate Automatic Database Backups'
          action={this.activateBackups.bind(this)}
        />

    if(this.props.currentUser && this.props.currentCustomer.is_trial) {
      if(this.props.currentCustomer.has_payment_method) {
        return (
          <div className={classes.join(' ')}>
            <Toolbar subsection={this.section}>
              <DropDown items={types['apps__backups']} type='toolbar' />
            </Toolbar>
            <PreLoader loading={this.state.loading}>
              <div className={styles.holder}>
                <EmptyState
                  title="Automatic Database Backups can be activated only after your first billing cycle"
                  description="Need Database Backups sooner?"
                  cta='Contact Support'
                  action={this.handleTeamDeskOpen.bind(this)}
                />
              </div>
            </PreLoader>
            <TeamDesk open={this.state.isTeamDeskOpen} />
          </div>
        )
      }
        return (
          <div className={classes.join(' ')}>
            <Toolbar subsection={this.section} />
            <PreLoader loading={this.state.loading}>
              <EmptyState
                title="Automatic Database Backups can be activated only after your first billing cycle"
                description="Add your credit card to manage your apps without interruption."
                cta='Add Credit Card'
                action={this.navigateToAddCard.bind(this)}
              />
            </PreLoader>
            <TeamDesk open={this.state.isTeamDeskOpen} />
          </div>
        );

    }

    return (
      <div className={classes.join(' ')}>
        <Toolbar subsection={this.section} />
        <PreLoader loading={this.state.loading}>
          <div className={styles.holder}>
            {
              !this.state.showAfterActivationThankYouMessage && !this.state.showAfterDeActivationThankYouMessage
                ? (this.state.showAlreadyComponent ? alreadyActivated : activateComponent)
                : null
            }
            {
              this.state.showAfterActivationThankYouMessage &&
                afterActivationThankYouMessage
            }
            {
              this.state.showAfterDeActivationThankYouMessage &&
                afterDeActivationThankYouMessage
            }
          </div>
        </PreLoader>

        {activateBackupsModal}
        {deActivateBackupsModal}

        <TeamDesk open={this.state.isTeamDeskOpen} />
      </div>
    );
  }
}
